import { render } from "./CustomToastMessage.vue?vue&type=template&id=473b0b58"
import script from "./CustomToastMessage.vue?vue&type=script&lang=js"
export * from "./CustomToastMessage.vue?vue&type=script&lang=js"
script.render = render

export default script